import React from "react";
import { Select } from "antd";
import { useSelector } from "react-redux";
import { selectVersions } from "../../../../core/data/redux/projects/selectors";
import type { Version } from "../../../../core/data/redux/projects/types";

interface VersionPickerProps {
  value: number | null | undefined;
  onChange: (versionId: number | null) => void;
  size?: "small" | "middle" | "large";
  label?: string;
  disabled?: boolean;
}

const VersionPicker: React.FC<VersionPickerProps> = ({
  value,
  onChange,
  size = "middle",
  label = "Select version",
  disabled,
}) => {
  const versions = useSelector(selectVersions);

  return (
    <Select
      allowClear
      size={size}
      style={{ height: 36 }}
      className="w-100"
      placeholder={label}
      value={value ?? undefined}
      onChange={(v) => onChange(v ?? null)}
      disabled={disabled}
      options={versions
        .filter((v: Version) => !v.archived)
        .map((v: Version) => ({
          value: v.id,
          label: `${v.name}${v.released ? " ✓" : ""}`,
        }))}
    />
  );
};

export default VersionPicker;
